import { service } from "@/services/api.ts";
import { printDeliveryDocketMobile } from "@/types/common";

export const commonService = {
  printDeliveryDocket: (params: string) => service.post(`deliveryDockets/print-by-delivery-no/${params}`, {}),
  printDeliveryDocketIOS: (params: printDeliveryDocketMobile) =>
    service.post(`deliveryDockets/print-by-delivery-no/${params.deliveryDocketNo}`, {
      template: "delivery_docket_print_template_for_ios"
    }),
  printDeliveryDocketAndroid: (params: printDeliveryDocketMobile) =>
    service.post(`deliveryDockets/print-by-delivery-no/${params.deliveryDocketNo}`, {
      template: "delivery_docket_print_template_for_android"
    })
};
